export default "__VITE_ASSET__DVUS1nvb__"